import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";

export const bootstrap = () => {
  ReactDOM.render(<App />, document.getElementById("root"));
};
